import React, { useContext } from 'react';
import useSectionStyles from './styles';
import PageContext from '../../contexts/pageContext';

export default function List({ sectionData }) {
  const {
    layout: { containerWidth },
    isMobile
  } = useContext(PageContext);
  const classes = useSectionStyles({ containerWidth, isMobile });
  const [nodeData] = sectionData.components;

  const getNumber = (val) => {
    return val.toString().length == 1 ? '0' + val : val;
  };
  return (
    <section className={classes.section}>
      <div className={classes.sectionContainer}>
        <div className={classes.subTitleHeading}>
          <span
            ref={nodeData?.cardHeading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.cardHeading.metadata.value
            }}
          />
        </div>
        <h2 className={classes.heading}>
          <span
            ref={nodeData?.title?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.title.metadata.value
            }}
          />
        </h2>

        <div className={classes.contentContainer}>
          {nodeData.contentList.components.map((dt, ind) => {
            return (
              <div key={ind} className={classes.content}>
                <div className={classes.contentNumber}>
                  {getNumber(ind + 1)}
                </div>
                <div className={classes.contentText}>
                  <h3
                    ref={dt?.contentHeading?.refSetter}
                    className={classes.contentHeading}
                    dangerouslySetInnerHTML={{
                      __html: dt.contentHeading.metadata.value
                    }}
                  />
                  <p
                    ref={dt?.contentPara?.refSetter}
                    className={classes.contentPara}
                    dangerouslySetInnerHTML={{
                      __html: dt.contentPara.metadata.value
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
